import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router"
import { useHistory } from "react-router-dom"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../../component/index.jsx"
import { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { stringFormatting, toHectare, toMeter } from "../../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import {
  ICON_CONSTANTS,
  ILLUSTRATION_CONSTANTS
} from "../../../../../../constants/ImageConstants.js"
import { FloatingSelectArea } from "../../../../../../component/atoms/FloatingSelectArea/index.jsx"
import { CloudDownloadOutlined } from "@material-ui/icons"
import {
  clearDEtailDownloadSubmission,
  getDetailDownloadSubmission
} from "../../../../../../redux/actions/SubmissionAction.jsx"
import { toast } from "react-toastify"
import SVG from "react-inlinesvg"
import { ApplicationSeedCertificationFormDownload } from "../../../../../../component/molecule/Print/ApplicationSeedCertificationFormDownload.jsx"
import { DATE_TYPE_ENUM, ROUTING_STATUS } from "../../../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../../../constants/PrivilegeConstants.js"

export const CertificationBlock = ({ changePage, data, activeFilter, privilege }) => {
  const { t } = useTranslation()
  const params = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { General, Submission } = useSelector((state) => state)
  const [selectedRows, setSelectedRows] = useState([])
  const [index, setIndex] = useState(0)
  const [createdBy, setCreatedBy] = useState(null)
  const [createdDate, setCreatedDate] = useState(null)

  useEffect(() => {
    dispatch(clearDEtailDownloadSubmission())
  }, [])

  useEffect(() => {
    const prevTitle = document.title
    if (Submission?.detailDownloadSubmission?.length > 0) {
      Submission.detailDownloadSubmission?.map((item, index) => {
        setTimeout(() => {
          setIndex(index)
          document.title = `${item.block_code}`
          window.print()
          setTimeout(() => {
            toast(t("messages_response_success_download_submission"), {
              position: "top-center",
              autoClose: 5000,
              className: "bg-neutral-black",
              icon: <SVG src={ICON_CONSTANTS.BULLET_TICK} />,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "dark"
            })
            dispatch(clearDEtailDownloadSubmission())
          }, 1000)
        }, 5000)
      })
    }
    return () => {
      document.title = prevTitle
    }
  }, [Submission?.detailDownloadSubmission])

  useEffect(() => {
    if (params?.tab === ROUTING_STATUS.CERTIFICATION_STATUS_STRING.SUBMITTED) {
      return (
        setCreatedBy(t("table_header_created_by")), setCreatedDate(t("table_header_created_date"))
      )
    } else if (params?.tab === ROUTING_STATUS.CERTIFICATION_STATUS_STRING.REJECTED) {
      return (
        setCreatedBy(t("table_header_reject_by")), setCreatedDate(t("table_header_reject_date"))
      )
    } else {
      return (
        setCreatedBy(t("table_header_received_by")), setCreatedDate(t("table_header_received_date"))
      )
    }
  }, [params?.tab])

  const handleBulkDownloadSubmission = () => {
    if (selectedRows.length) {
      const body = {
        block_ids: selectedRows.map((e) => e.block_id)
      }
      dispatch(getDetailDownloadSubmission(body))
    }
  }

  function uiCode(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.block_code)}
        </div>
        <div className={"d-flex"}>
          <div>{stringFormatting(e?.sub_district_name)}</div>
        </div>
      </>
    )
  }

  function uiMitra(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.mitra_name)}
        </div>
        <div>{stringFormatting(e?.mitra_code)}</div>
      </div>
    )
  }

  function uiArea(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {toMeter(stringFormatting(e?.land_area_meter))}
        </div>
        <div>{toHectare(stringFormatting(e?.land_area_ha))}</div>
      </div>
    )
  }

  function uiVarietas(e) {
    return (
      <>
        <div>{stringFormatting(e?.variety_name)}</div>
      </>
    )
  }

  function uiPlantingDate(e) {
    return (
      <>
        <div>
          {stringFormatting(timeStampToDate(e?.planting_date, DATE_TYPE_ENUM.ISO_DATE_STRAP))}
        </div>
      </>
    )
  }

  function uiDate(e) {
    return (
      <div>
        <div>
          {stringFormatting(timeStampToDate(e?.submitted_date, DATE_TYPE_ENUM.ISO_DATE_STRAP))}
        </div>
        <div>
          {stringFormatting(timeStampToDate(e?.submitted_date, DATE_TYPE_ENUM.ISO_TIME_ID))}
        </div>
      </div>
    )
  }

  function uiCreateBy(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder font-size-lg mb-1"}>
          {stringFormatting(e?.submitted_by)}
        </div>
        <div>{stringFormatting(e?.submitted_role)}</div>
      </div>
    )
  }

  const uiAction = (e) => {
    return (
      <div>
        <OverlayTrigger overlay={<Tooltip id="products-detail-tooltip">Detail</Tooltip>}>
          <div
            onClick={() => {
              history.push(
                RoutesConstants.SUBMISSION.DETAIL_BLOCK_CERTIFICATION(params?.tab, e?.block_id)
              )
            }}
            className={"btn btn-icon btn-list btn-hover-secondary btn-sm mx-3"}>
            <DetailSvgIcon />
          </div>
        </OverlayTrigger>
      </div>
    )
  }

  const columns = [
    {
      dataField: "code",
      text: t("table_header_block_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "mitra",
      text: t("table_header_mitra"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      }
    },
    {
      dataField: "totalAreaLand",
      text: t("table_header_land_area_only"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiArea
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "varietas",
      text: t("table_header_varietas"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiVarietas
      }
    },
    {
      dataField: "AC.activityDate",
      text: t("table_header_planting_date"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiPlantingDate
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "createdDate",
      text: createdDate,
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDate
      },
      headerStyle: () => {
        return { width: "10%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "submitted_by",
      text: createdBy,
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCreateBy
      },
      headerStyle: () => {
        return { width: "10%" }
      }
    },
    privilege.indexOf(PRIVILEGE_ENUM.CERTIFICATION_DETAIL_SUBMISSION) > -1 && {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  return (
    <>
      {Submission?.detailDownloadSubmission?.length > 0 && (
        <ApplicationSeedCertificationFormDownload
          data={Submission?.detailDownloadSubmission[index]}
        />
      )}
      <div className={"d-print-none"}>
        {selectedRows.length > 0 && (
          <FloatingSelectArea
            totalArea={selectedRows.length}
            buttonlabel={t("label_submission_download")}
            buttonColor={"primary"}
            label={t("label_block_selected")}
            frontIcon={<CloudDownloadOutlined className={"mr-4"} />}
            handleClick={() => {
              handleBulkDownloadSubmission()
            }}
          />
        )}
        <Card>
          <CardBody>
            {General.loading ? (
              <TableSkeleton column={8} row={10} />
            ) : data?.pageData?.length === 0 ? (
              <EmptyCard
                image={
                  activeFilter
                    ? ILLUSTRATION_CONSTANTS.NOT_FOUND_DATA
                    : ILLUSTRATION_CONSTANTS.EMPTY_STATE_DATA
                }
                body={
                  activeFilter
                    ? t("messages_response_response_not_found_data")
                    : t("messages_response_empty_state", { name: "blok" })
                }
                subtitle={activeFilter ? t("messages_response_sub_response_not_found_data") : ""}
              />
            ) : (
              ""
            )}
            <TableView
              dataTable={data?.pageData ?? []}
              loadingGetData={false}
              callbackAfterPageChange={changePage}
              columnProperties={columns}
              currentPage={data?.page?.currentPage}
              currentElement={data?.page?.currentElement}
              totalCount={data?.page?.totalCount}
              rowClasses={() => {
                return "cursor-pointer"
              }}
              keyField={"block_id"}
              selectable={privilege.indexOf(PRIVILEGE_ENUM.CERTIFICATION_DOWNLOAD_SUBMISSION) > -1}
              onSelect={(row, isSelected) => {
                let rows = JSON.parse(JSON.stringify(selectedRows))
                if (isSelected) {
                  rows.push(row)
                } else {
                  rows = rows.filter((r) => r.block_id !== row.block_id)
                }
                setSelectedRows(rows)
              }}
              onSelectAll={(isSelect, rows) => {
                let rowses = JSON.parse(JSON.stringify(selectedRows))
                if (isSelect) {
                  if (rows?.length > 0) {
                    rows?.map((e) => {
                      rowses.push(e)
                    })
                  }
                } else {
                  if (rows?.length) {
                    let rowsesNew = rowses
                    rows?.map((row) => {
                      const removeIndex = rowses.findIndex((e) => e?.block_id === row?.block_id)
                      rowsesNew.splice(removeIndex, 1)
                    })
                    rowses = rowsesNew
                  }
                }
                setSelectedRows(rowses)
              }}
            />
          </CardBody>
        </Card>
      </div>
    </>
  )
}